import React from "react";
import ManageAssessment from "../Assessment/ManageAssessment";
import { ASSESSMENT_TYPES } from "../Assessment/assessmentType";

// Exams and Unit Tests share one screen; only the type differs.
const ManageExam = () => <ManageAssessment type={ASSESSMENT_TYPES.exam} />;

export default ManageExam;
